import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useOnboardingState } from '@/hooks/use-onboarding-state';
import { PrivacyUpdateNotice } from '@/components/legal/PrivacyUpdateNotice';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const { state: onboardingState } = useOnboardingState();
  const location = useLocation();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
          <p className="mt-4 text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 첫 실행 시 온보딩으로 리다이렉트
  if (!onboardingState.hasCompletedOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  // 방침 개정 고지는 인증 영역 전체에 걸린다 — MainLayout·RedesignLayout 둘 다
  // 이 아래에 있어서, 여기 한 번만 두면 레이아웃마다 중복으로 붙일 필요가 없다.
  return (
    <>
      {children}
      <PrivacyUpdateNotice />
    </>
  );
}
